/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Create_Email_ExistsInputs */

const en_admin_create_email_exists = /** @type {(inputs: Admin_Create_Email_ExistsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This email is already taken. Please choose a different email.`)
};

const de_admin_create_email_exists = /** @type {(inputs: Admin_Create_Email_ExistsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diese E-Mail ist bereits vergeben. Bitte wähle eine andere E-Mail.`)
};

/**
* | output |
* | --- |
* | "This email is already taken. Please choose a different email." |
*
* @param {Admin_Create_Email_ExistsInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const admin_create_email_exists = /** @type {((inputs?: Admin_Create_Email_ExistsInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Create_Email_ExistsInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_admin_create_email_exists(inputs)
	return en_admin_create_email_exists(inputs)
});